import script from "./AddressReceive.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddressReceive.vue?vue&type=script&setup=true&lang=ts"

import "./AddressReceive.vue?vue&type=style&index=0&id=5b5ea64c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b5ea64c"]])

export default __exports__